
import React, { useEffect, useState } from "react";
import bannerImage from "../img/whatwedobrief.jpeg";
import OnlyButtonrange from "./OnlyButtonrange";
import brochure from "./IIA_JAVA_FULL STACK_BROCHURE.pdf";
import Springbootkey from "./Springbootkey";

const Banner = () => {
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    setAnimate(true);
  }, []);

  return (
    <>
      <style>{`
        .rb-banner {
          position: relative;
          width: 100%;
          min-height: 550px;
          overflow: hidden;
        }

        .rb-banner-img {
          position: absolute;
          inset: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .rb-banner-overlay {
          position: absolute;
          inset: 0;
          background: rgba(5,42,102,0.60);
          z-index: 1;
        }

        .rb-banner-content {
          position: absolute;
          inset: 0;
          z-index: 2;
          display: flex;
          align-items: center;
          padding: 0 6%;
          color: #fff;
        }

        .rb-text {
          max-width: 900px;
          opacity: 0;
          transform: translateY(40px);
          transition: all 1s ease;
        }

        .rb-text.show {
          opacity: 1;
          transform: translateY(0);
        }

        .rb-title {
          font-size: 42px;
          font-weight: 700;
          line-height: 1.2;
        }

        .rb-title span {
          color: #ffa200;
        }

        .rb-desc {
          margin-top: 18px;
          font-size: 16px;
          line-height: 1.8;
          text-align: justify;
          max-width: 850px;
        }

        .rb-features {
          margin-top: 20px;
          display: flex;
          flex-wrap: wrap;
          gap: 12px;
        }

        .rb-feature {
          background: rgba(255,255,255,0.15);
          padding: 8px 15px;
          border-radius: 25px;
          font-size: 14px;
        }

        .rb-actions {
          margin-top: 25px;
          display: flex;
          gap: 15px;
          flex-wrap: wrap;
          align-items: center;
        }

        .rb-btn {
          background: #ffa200;
          color: #fff;
          padding: 12px 22px;
          border-radius: 30px;
          border: none;
          cursor: pointer;
          font-weight: 600;
          text-decoration: none;
        }

        .rb-star {
          color: gold;
          font-size: 20px;
        }

        @media (max-width: 768px) {
          .rb-banner {
            min-height: 100vh;
          }

          .rb-banner-content {
            padding: 20px;
            text-align: center;
          }

          .rb-title {
            font-size: 28px;
          }

          .rb-desc {
            text-align: center;
            font-size: 14px;
          }

          .rb-features,
          .rb-actions {
            justify-content: center;
          }
        }
      `}</style>

      <section className="rb-banner">
        <img
          src={bannerImage}
          alt="Spring Boot and MySQL Course"
          className="rb-banner-img"
        />

        <div className="rb-banner-overlay"></div>

        <div className="rb-banner-content">
          <div className={`rb-text ${animate ? "show" : ""}`}>
            <h1 className="rb-title">
              Spring Boot & <span>MySQL Development</span>
            </h1>

            <p className="rb-desc">
              Spring Boot and MySQL are among the most widely used technologies
              for modern backend application development. This course provides
              hands-on training in REST API development, database management,
              authentication, CRUD operations, Spring Data JPA, Hibernate, and
              enterprise application architecture. Students will learn to build
              scalable, secure, and production-ready backend systems used in
              real-world software applications.
            </p>

            <div className="rb-features">
              <span className="rb-feature">✅ Core Java</span>
              <span className="rb-feature">✅ Spring Boot</span>
              <span className="rb-feature">✅ Spring MVC</span>
              <span className="rb-feature">✅ Hibernate & JPA</span>
              <span className="rb-feature">✅ MySQL Database</span>
              <span className="rb-feature">✅ REST APIs</span>
              <span className="rb-feature">✅ JWT Security</span>
              <span className="rb-feature">✅ Live Projects</span>
              <span className="rb-feature">✅ Placement Support</span>
            </div>

            <div className="rb-actions">
              <span className="rb-star">⭐⭐⭐⭐⭐</span>

              <a href={brochure} download className="rb-btn">
                Download Brochure
              </a>

              <button
                className="rb-btn"
                onClick={() => {
                  const mobile = "8096120173";

                  if (
                    window.confirm(
                      `Call Details\n\nMobile: ${mobile}\n\nDo you want to call now?`
                    )
                  ) {
                    window.location.href = `tel:${mobile}`;
                  }
                }}
              >
                Call Now
              </button>
            </div>
          </div>
        </div>
      </section>

      <div className="button-range-wrapper">
        <OnlyButtonrange />
      </div>
      <Springbootkey/>
    </>
  );
};

export default Banner;

